// Guidance shown on the score-setup screen. Field-specific industry references
// exist only for a few well-known attributes; everything else falls back to
// generic, always-true advice. This is illustrative reference content for the
// guided setup, not a live data feed — extend REFERENCES as real per-field
// guidance becomes available. Final wording is pending content review
// (I360A-2676); only the strings below change when that lands.

// Identity marker so i18next-parser (`npm run generate:translations`) sees
// these strings as literal t() keys; the real translation happens where
// they render (ScoreSetupHeader wraps the returned text in t()).
const t = (key: string): string => key;

export const ARTIFAKT_FONT =
	'ArtifaktElement, -apple-system, BlinkMacSystemFont, Roboto, Helvetica, Arial, sans-serif';

export const GENERIC_SCORE_GUIDANCE = t(
	'Assign higher scores to the values you consider riskier. Check coverage above — for unknown or "--" values, use the score that fits your organisation (many treat them as riskier and score higher). Either way they\'re flagged in your model results, so you can review them there.',
);

export const GENERIC_SCORE_GUIDANCE_NO_COVERAGE = t(
	'Assign higher scores to the values you consider riskier. For unknown or "--" values, use the score that fits your organisation (many treat them as riskier and score higher). Either way they\'re flagged in your model results, so you can review them there.',
);

export const RISK_ONLY_GUIDANCE = t(
	'Assign higher scores to the values you consider riskier.',
);

const REFERENCES: Record<string, string> = {
	material: t(
		'Industry reference: AC 8–9 (3–4× higher failure) · VCP 6–7 · PVC 2–3 · DI 6–7 · CI 7–9 · Unknown or "--": score to fit your organisation (many use 5–7)',
	),
};

// Keyed on the component's source field (e.g. `material`), not its
// user-typed name, so hand-named components still get the right reference.
export const scoreGuidance = (
	fieldName: string | undefined,
	hasCoverage = true,
): string => {
	const generic = hasCoverage
		? GENERIC_SCORE_GUIDANCE
		: GENERIC_SCORE_GUIDANCE_NO_COVERAGE;
	if (!fieldName) return generic;
	return REFERENCES[fieldName.trim().toLowerCase()] ?? generic;
};

// A continuous low→high risk reference (traffic-light ramp: green → amber
// → red), rendered only as ScoreLegend's caption strip above the table.
const RISK_RAMP_STOPS = [
	{ offset: 0, color: '#7fbf83' },
	{ offset: 0.45, color: '#f2c94c' },
	{ offset: 0.7, color: '#e0955a' },
	{ offset: 1, color: '#cf6b6b' },
];

export const RISK_RAMP = `linear-gradient(90deg, ${RISK_RAMP_STOPS.map(
	s => `${s.color} ${s.offset * 100}%`,
).join(', ')})`;
